import styled from "@emotion/styled";
import { Anchor } from "../../common/components/ui";

export const StyledAnchor = styled(Anchor)`
  cursor: pointer;
`;
